import React, { useCallback, useMemo, useState } from 'react';
import { find, head } from 'lodash';
import { NavigationBar } from '@hub-mono/ui';

export const TabLinks = React.memo(props => {
    const { onHoverChange } = props;
    const currentTab = props.activeTab ? find(props.tabs, tab => tab.id === props.activeTab) : head(props.tabs);
    const [activeTab, setActiveTab] = useState(currentTab);

    const toggle = useCallback(
        item => {
            setActiveTab(item);
            props.toggle(item.id);
        },
        [props]
    );

    const navigationBarData = useMemo(() => {
        return props.tabs.map(el => ({
            ...el,
            label: el.title,
        }));
    }, [props.tabs]);

    const handleClick = useCallback(
        (event, item) => {
            toggle(item);
            onHoverChange?.({
                title: item.title,
                desc: item.desc,
            });
        },
        [onHoverChange, toggle]
    );

    return <NavigationBar active={activeTab} options={navigationBarData} onClick={handleClick} />;
});

export default TabLinks;
